module.exports = __webpack_public_path__ + "img/md.9916d222.svg";